<template>
  <div class="col px-0 px-md-3">
    <ColorPointsHeader :message="greenHeaderMessage" color="rgba(190, 206, 35, 0.5)" />
    <div class="row center" v-for="(focusElement, key) in focus" :key="key">
      <h2 class="row center justify-content-center text-secondary font-weight-bold pt-5" v-html="focusElement.titre"></h2>
      <div class="col-12 text-center" v-html="focusElement.texte"></div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import { getFocus } from '../../../mixins/getFocus'

export default {
  name: 'Mentions',
  mixins: [getFocus],
  components: {
    ColorPointsHeader: () => import('../../../components/ColorPointsHeader')
  },
  data () {
    return {
      greenHeaderMessage: {
        titre: '',
        sousTitre: ''
      },
      focus: []
    }
  },
  async beforeMount () {
    await this.getFocus('CG Courtage', 'Mentions Légales')
      .then(res => {
        this.focus = res
        this.greenHeaderMessage.titre = this.focus.cartouche ? this.focus.cartouche.titre : ''
        this.greenHeaderMessage.sousTitre = this.focus.cartouche ? this.focus.cartouche.texte : ''
        delete this.focus.cartouche
      })
  }
}
</script>
